<template>
    <div v-show="visible">
        <el-dialog title="查看成绩名单" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="1100px">    
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.name" placeholder="姓名"></el-input>
                </div>
            </div>
            &nbsp;
            <div style="display: inline-block; height:40px;">
                <el-button type="primary" icon="search" @click="getData()">查询</el-button>
            </div>

            <el-table
                :data="content"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                height="600"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                border
                default-expand-all>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <template v-for="(item,index) in head">
                    <el-table-column :prop="item.column_name" :label="item.column_comment" :show-overflow-tooltip="true" :key="index"></el-table-column>
                </template>
                <el-table-column label="操作" width="80px">
                    <template slot-scope="scope">
                         <el-button style="color:#387EE8;"
                            @click.native.prevent="printScore(scope.row)"
                            type="text"
                            size="small">
                            打印成绩
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="batchPrint()">批量打印</el-button>
                <el-button type="danger" @click="visible=false">关闭</el-button>
            </span>    
        </el-dialog>
        <!--打印成绩 -->
        <div v-if="printScoreVisible">
            <printScore ref="printScore"></printScore>
        </div>
        <!--批量打印成绩 -->
        <div v-if="batchPrintScoreVisible">
            <batchPrintScore ref="batchPrintScore"></batchPrintScore>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../common/http'; 
    import printScore from './PrintScore.vue';
    import batchPrintScore from './BatchPrintScore.vue';

    export default {
        data(){
            return{
                loading:false,
                loadingText:"",

                visible: false,
                printScoreVisible:false,
                batchPrintScoreVisible:false,
                scoreListId:"",
                head:[],
                content:[],
                form:{
                    name:"",
                    identityCard:""
                },
                // added by lig  20250512
                scoreListData:undefined
            }
        },
        components: {
            printScore,batchPrintScore
        },
        created:function () {
        },
        methods:{
            indexMethod(index) {
                return index+1;
            },
            init(data){
                // 重置内容
                this.head=[]
                this.content=[]
                
                this.visible=true
                this.scoreListId = data.id
                this.scoreListData = data
                this.getData()
            },
            getData(){
                this.loading=true
                this.loadingText="数据加载中..."

                let url  = this.studensubjecscoreListUrl
                let data = {
                    scoreListId:this.scoreListId,
                    name:this.form.name
                };       
                // console.log(JSON.stringify(data))
                // return;
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){ 
                       this.head=res.data.head
                       this.content=res.data.content
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                },(err)=>{
                    this.loading=false
                });
            },
            dialogClose(done){
                done()
                this.$reload
            },
            // 打印成绩
            printScore(row){
                // 触发详情界面
                this.printScoreVisible = true
                this.$nextTick(() => {
                    this.$refs['printScore'].init(row, this.scoreListData)
                })
            },
            batchPrint() {
                // 触发详情界面
                this.batchPrintScoreVisible = true
                this.$nextTick(() => {
                    this.$refs['batchPrintScore'].init(this.content, this.scoreListData)
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/score/ScoreDetails.vue